module.exports = __webpack_public_path__ + "static/media/springbig-logo-grey.0051af0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/springbig-logo-grey.svg
// module id = 2427
// module chunks = 0